import { useContext, createContext } from 'react';
import { useThirdPartyWidgetDetailsReducer } from '../reducers/thirdPartyWidgetDetailsReducer';
import { jsx as _jsx } from "react/jsx-runtime";
const ThirdPartyWidgetDetailsContext = /*#__PURE__*/createContext(null);
const ThirdPartyWidgetDetailsDispatch = /*#__PURE__*/createContext(null);
export const useContextWithDispatch = (Context, DispatchContext) => {
  const context = useContext(Context);
  const dispatch = useContext(DispatchContext);
  if (!context || !dispatch) {
    throw new Error('useContextWithDispatch must be used within a Context + Dispatch Provider');
  }
  return [context, dispatch];
};
export default function ThirdPartyWidgetDetailsProvider({
  children
}) {
  const [state, dispatch] = useThirdPartyWidgetDetailsReducer();
  return /*#__PURE__*/_jsx(ThirdPartyWidgetDetailsContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(ThirdPartyWidgetDetailsDispatch.Provider, {
      value: dispatch,
      children: children
    })
  });
}
export const useThirdPartyWidgetDetailsContext = () => useContextWithDispatch(ThirdPartyWidgetDetailsContext, ThirdPartyWidgetDetailsDispatch);